import { render } from "./InscriptionThead.vue?vue&type=template&id=9e835180&scoped=true"
import script from "./InscriptionThead.vue?vue&type=script&lang=js"
export * from "./InscriptionThead.vue?vue&type=script&lang=js"

import "./InscriptionThead.vue?vue&type=style&index=0&id=9e835180&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e835180"]])

export default __exports__